import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const selectedServiceValueFormState = atom<string | null>({
    key: 'selectedServiceValueFormState',
    default: null,
});

export const useSelectedServiceValueFormValue = () => useRecoilValue(selectedServiceValueFormState);
export const useSetSelectedServiceValueFormState = () => useSetRecoilState(selectedServiceValueFormState);
